module.exports = __webpack_public_path__ + "static/img/class_9.e3b4f717.jpg";